var render = function render(_c,_vm){return (
    _vm.props.publicationState &&
      _vm.props.publicationState.publicationStateId !== null &&
      _vm.props.publicationState.publicationStateId !== undefined
  )?_c('span',{class:`price-list-status-${_vm.props.publicationState.publicationStateId} price-list-status-text`},[_vm._v(" "+_vm._s(_vm.parent.$t( `priceList.publicationStateDecode.${_vm.props.publicationState.publicationStateId}` ))+" ")]):_c('span',{class:`price-list-status-${_vm.props.status} price-list-status-text`},[_vm._v(" "+_vm._s(_vm.parent.$t(`priceList.statusDecode.${_vm.props.status}`))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }